import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';

/**
 * Hook to trigger tag stats recalculation for an account.
 * Developer-only admin operation.
 *
 * Uses the endpoint: POST /admin/accountoperations/setTagStats?accountId={accountId}
 */
export const useSetTagStatsMutation = ({
	onError,
	onSuccess,
	userSession,
}: {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	userSession: Api.UserSessionContext;
}) => {
	return useMutation({
		mutationFn: ({ accountId }: { accountId: string }) => {
			return new Promise((resolve, reject) => {
				userSession.webServiceHelper
					.callWebServiceRawResponse(
						`admin/accountoperations/setTagStats?accountId=${accountId}`,
						'POST',
						null,
						resolve,
						reject
					)
					.catch(reject);
			});
		},
		onError,
		onSuccess,
	});
};
